// TODO check this

import { format, setSeconds, startOfDay } from "date-fns";
import {
  CSRF_TOKEN_HEADER_KEY,
  CACHE_TIMEOUT,
  CSRF_TOKEN_KEY,
  ONE_HOUR,
  USER_ROLES,
  SUBSCRIPTION_STATUS,
  LAST_USED_VOICES_COUNT,
} from "../constants";

export const isDefaultMicrophone = (current /*, list*/) => {
  return current && current.id === "default";
  // TODO investigate how it looks on other OS's
  /*
  if (!current || list.length === 0) {
    return false;
  }
  return true;
  */
};

// TODO replace with axios?
export const xhrUpload = (options) => {
  const {
    type,
    url,
    successHandler,
    errorHandler,
    uploadProgressHandler,
    file,
    fields,
  } = options;
  if (!url || !successHandler || !errorHandler || !file) {
    throw new Error("Invalid upload params");
  }
  let formData = new FormData();
  formData.append("data", file);
  if (fields) {
    fields.forEach((field) => {
      formData.append(field.name, field.data);
    });
  }

  const xhr = new XMLHttpRequest();

  xhr.addEventListener("load", (e) => {
    if (xhr.status === 200) {
      successHandler(xhr.response);
    } else {
      errorHandler(xhr.response, xhr.status);
    }
  });
  xhr.addEventListener("error", (e) => {
    // console.log("Error uploadDataset");
  });
  xhr.upload.addEventListener("progress", uploadProgressHandler);

  xhr.withCredentials = true;
  xhr.open(type || "POST", url);
  xhr.setRequestHeader(CSRF_TOKEN_HEADER_KEY, getCsrfToken());
  xhr.send(formData);
};

export const slugify = (string) => {
  const a = "àáäâãåèéëêìíïîòóöôùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;";
  const b = "aaaaaaeeeeiiiioooouuuuncsyoarsnpwgnmuxzh------";
  const p = new RegExp(a.split("").join("|"), "g");
  return string
    .toString()
    .toLowerCase()
    .replace(/\s+/g, "-") // Replace spaces with -
    .replace(p, (c) => b.charAt(a.indexOf(c))) // Replace special characters in a with b
    .replace(/&/g, "-and-") // Replace & with ‘and’
    .replace(/[^\w-]+/g, "") // Remove all non-word characters such as spaces or tabs
    .replace(/--+/g, "-") // Replace multiple — with single -
    .replace(/^-+/, "") // Trim — from start of text
    .replace(/-+$/, ""); // Trim — from end of text
};

export const checkCache = (cachedAt) => Date.now() - cachedAt > CACHE_TIMEOUT;

export const formatBytes = (bytes, decimals = 1) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};

export async function durationOfAudioFile(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function (event) {
      let audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      audioContext.decodeAudioData(
        event.target.result,
        function (buffer) {
          resolve(
            buffer.duration < 1 ? buffer.duration : Math.floor(buffer.duration)
          );
        },
        (e) => reject(e)
      );
    };
    reader.readAsArrayBuffer(file);
  });
}

export const formatSeconds = (seconds, customFormat = undefined) => {
  const tmpDate = startOfDay(new Date());
  const date = setSeconds(tmpDate, seconds);
  const hour = date.getHours();
  const hasHour = !!hour;

  const strFormat = customFormat
    ? customFormat
    : hasHour
    ? "HH:mm:ss"
    : "mm:ss";
  return format(date, strFormat);
};

export const secToHHMMSS = (
  sec,
  isMilliseconds = false,
  showMilliseconds = true
) =>
  new Date(isMilliseconds ? sec : sec * 1000)
    .toISOString()
    .substr(11, showMilliseconds ? 11 : 8);

// TODO refactor?
export const secToMMSS = (
  sec,
  isMilliseconds = false,
  showLeadingZero = true,
  showMilliseconds = true
) => {
  const _sec = sec || 0;
  return new Date(isMilliseconds ? _sec : _sec * 1000)
    .toISOString()
    .substr(
      showLeadingZero ? 14 : 15,
      (showLeadingZero ? 5 : 4) + (showMilliseconds ? 3 : 0)
    );
};

export const secToTimeObject = (totalSeconds, isHours = false) => {
  const date = new Date(totalSeconds * 1000);
  const totalMinutes = date.getMinutes() + date.getUTCHours() * 60;

  return isHours
    ? { h: date.getUTCHours(), m: date.getMinutes(), s: date.getSeconds() }
    : { m: totalMinutes, s: date.getSeconds() };
};

// TODO move to date-fns/moment
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const dateToDayMonthString = (date) => {
  return `${date.getDate()} ${months[date.getMonth()]}`;
};
export const dateToDayMonthYearString = (date) => {
  return `${dateToDayMonthString(date)} ${date.getFullYear()}`;
};
export const dateToMonthYearString = (date) => {
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const downloadFileFromUrl = (url, name = undefined) => {
  const file_path = `${url}?token=${getCsrfToken()}`;
  const a = document.createElement("A");
  // FYI custom name works for same domain
  a.download = name || url.substr(url.lastIndexOf("/") + 1);
  a.href = file_path;
  a.click();
  a.remove();
};

// TODO: in the future create some sort of standardised error message format
//       to avoid parsing plain english messaged from the BE. This could also
//       help with internationalization

export const formatErrorMessage = (
  errorMessage,
  showDefaultError = true,
  defaultErrorMessage = undefined
) => {
  if (/support use of tts speaker/.test(errorMessage)) {
    return `Voice doesn't support use of tts speaker`;
  }
  if (/support m2o/.test(errorMessage)) {
    return `Voice doesn't support m2o`;
  }
  if (/Max allowed audio duration/.test(errorMessage)) {
    return errorMessage.replace(
      "Max allowed audio duration",
      "Max allowed audio duration for trial users"
    );
  }
  if (/Project with owner.*already exists/.test(errorMessage)) {
    return "Project with this name already exists";
  }
  if (/Incorrect project name/.test(errorMessage)) {
    return "Incorrect project name";
  }
  if (/There is already a resource with the values/.test(errorMessage)) {
    return "Folder with same name already exists.";
  }
  if (/Failed to compute waveform data/.test(errorMessage)) {
    return "Invalid file(s)";
  }
  if (!showDefaultError) {
    return errorMessage;
  }
  if (defaultErrorMessage) {
    return defaultErrorMessage;
  }
  return "Something went wrong, please restart conversion";
};

// TODO fix this?
export const pitchCorrectionMultiply = (value) => (value * Math.log(2)) / 12;
export const pitchCorrectionDivide = (value) => (value * 12) / Math.log(2);
// export const pitchCorrectionMultiply = (value) => value;
// export const pitchCorrectionDivide = (value) => value;

export const isMoreThan24Hours = (date) => {
  const day = ONE_HOUR * 24;
  return date < Date.now() - day;
};

export const isMoreThanOneHour = (date, startDate = undefined) => {
  const value = ONE_HOUR;
  return date < (startDate ? Date.parse(startDate) : Date.now()) - value;
};

export const capitalizeFirstLetter = (
  [first, ...rest],
  locale = navigator.language
) => first.toLocaleUpperCase(locale) + rest.join("");

export const snakeCaseToSpaces = (s) =>
  s.split("_").map(capitalizeFirstLetter).join(" ");

export const sortByObjectKey = (array, rawKey) => {
  const splittedKey = rawKey.split("_");
  const key = splittedKey.slice(0, -1).join("_");
  const sortDESC = splittedKey[splittedKey.length - 1] === "desc";
  return array.sort((a, b) => {
    if (a[key] < b[key]) {
      return sortDESC ? 1 : -1;
    }
    if (a[key] > b[key]) {
      return sortDESC ? -1 : 1;
    }
    return 0;
  });
};

export const sortByArray = (array, sortArray, key = undefined) => {
  const newArray = [];
  const restArray = [];
  sortArray.forEach((k) => {
    const tmp = array.find((item) => (key ? item[key] === k : item === k));
    if (tmp) {
      newArray.push(tmp);
    }
  });
  array.forEach((item) => {
    if (!sortArray.includes(key ? item[key] : item)) {
      restArray.push(item);
    }
  });
  return [...newArray, ...restArray];
};

export const arrayDiff = (a, b) => a.filter((x) => !b.includes(x));
export const arrayContains = (a, b) => a.filter((x) => b.includes(x));

export const objectDiff = (objectFull, objectPartial) =>
  Object.entries(objectPartial).filter(
    ([field, obj2Value]) => objectFull[field] !== obj2Value
  );

export const getCsrfToken = () => localStorage.getItem(CSRF_TOKEN_KEY);

export const getRecordingLabel = (label, number) =>
  label || `Recording ${number}`;

export const generateRecordingFilename = ({
  project,
  folder,
  model,
  recordingId,
  name,
  recordingLabel,
}) => {
  const projectName = slugify(project.name.trim()).substr(0, 40);
  let folderName = slugify(folder.name.trim()).substr(0, 40);
  if (folderName === "") {
    folderName = "undisplayable-folder-name";
  }
  const label = slugify(recordingLabel).substr(0, 40);
  const modelTitle = model ? `${model.name}-` : "";
  const filename =
    `${projectName}-${folderName}-${modelTitle}${label}-${recordingId.substr(
      0,
      5
    )}.${name.split(".").pop()}`.toLocaleLowerCase();
  return filename;
};

export const isUserSubscribed = (user) => {
  const {
    roles,
    data: {
      stripe: { subscription_status },
    },
  } = user;
  return (
    roles.includes(USER_ROLES.ADMIN) ||
    roles.includes(USER_ROLES.PREPAID) ||
    (roles.includes(USER_ROLES.USER) &&
      [SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.TRIALING].includes(
        subscription_status
      ))
  );
};

export const generateIncrementedName = (
  initialLabel,
  existingNames,
  initialShouldIncludeCounter = true
) => {
  let checker = true;
  let counter = 1;
  let generatedName = initialShouldIncludeCounter
    ? `${initialLabel} ${counter}`
    : `${initialLabel}`;
  while (checker) {
    if (existingNames.includes(generatedName)) {
      generatedName = `${initialLabel} ${counter}`;
      counter++;
    } else {
      checker = false;
    }
  }
  return generatedName;
};

export const formatTime = (t) =>
  t < 60
    ? `${Math.round(t)} sec`
    : t < 3600
    ? `${Math.round(t / 60)} min`
    : `${Math.round(t / 3600)} h`;

export const getUserRole = (roles) => {
  return roles.includes(USER_ROLES.ADMIN)
    ? USER_ROLES.ADMIN
    : roles.includes(USER_ROLES.PREPAID)
    ? USER_ROLES.PREPAID
    : USER_ROLES.USER;
};

// redux utils
// receive array of createAsyncThunk functions
export const isPendingAction =
  (actionsToFilter = undefined) =>
  (action) => {
    if (!actionsToFilter) {
      return action.type.endsWith("/pending");
    }
    return (
      action.type.endsWith("/pending") &&
      actionsToFilter.map((a) => a.type).includes(action.type)
    );
  };
// receive array of createAsyncThunk functions
export const isFulfilledAction =
  (actionsToFilter = undefined) =>
  (action) => {
    if (!actionsToFilter) {
      return action.type.endsWith("/fulfilled");
    }
    return (
      action.type.endsWith("/fulfilled") &&
      actionsToFilter.map((a) => a.type).includes(action.type)
    );
  };
// receive array of createAsyncThunk functions
export const isRejectedAction =
  (actionsToFilter = undefined) =>
  (action) => {
    if (!actionsToFilter) {
      return action.type.endsWith("/rejected");
    }
    return (
      action.type.endsWith("/rejected") &&
      actionsToFilter.map((a) => a.type).includes(action.type)
    );
  };

export const dateToString = (date) => {
  // If date string doesn't contain timezone stamp, append 'GMT'
  // (in order to treat data received from server as already in GMT)

  // every date now contains a timestamp so we can return
  // new Date(date).toString();

  if (/[a-z]/i.test(date)) {
    date += " GMT";
  }
  return new Date(date).toUTCString();
};

export const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

export const randomItemFromArray = (arr) =>
  arr[Math.floor(Math.random() * arr.length)];

let lastUid = 0;

export const uid = () => lastUid++;

export const debounce = (func, timeout = 300) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
};

export const countries = [
  //{
  //  code: "au",
  //  label: "Australia",
  //  accentName: "Australian",
  //  phone: "61",
  //  suggested: true,
  //},
  {
    code: "cn",
    label: "China",
    accentName: "Chinese",
    phone: "86",
  },
  {
    code: "es",
    label: "Spain",
    accentName: "Spanish",
    phone: "34",
  },
  {
    code: "gb",
    label: "United Kingdom",
    accentName: "British",
    phone: "44",
  },
  {
    code: "in",
    label: "India",
    accentName: "Indian",
    phone: "91",
  },
  //{
  //  code: "kr",
  //  label: "Republic of Korea",
  //  accentName: "Korean",
  //  phone: "82",
  //},
  {
    code: "tr",
    label: "Turkey",
    accentName: "Turkish",
    phone: "90",
  },
  {
    code: "ua",
    label: "Ukraine",
    accentName: "Slavic",
    phone: "380",
  },
  {
    code: "us",
    label: "United States",
    accentName: "American",
    phone: "1",
    suggested: true,
  },
  //{
  //  code: "br",
  //  label: "Brazil",
  //  accentName: "Brazilian",
  //  phone: "55",
  //},
  //{
  //  code: "ng",
  //  label: "Nigeria",
  //  accentName: "Nigerian",
  //  phone: "234",
  //},
  //{
  //  code: "pt",
  //  label: "Portugal",
  //  accentName: "Portuguese",
  //  phone: "351",
  //},
  //{
  //  code: "it",
  //  label: "Italy",
  //  accentName: "Italian",
  //  phone: "39",
  //},
  {
    code: "de",
    label: "Germany",
    accentName: "German",
    phone: "49",
    suggested: true,
  },
  {
    code: "fr",
    label: "France",
    accentName: "French",
    phone: "33",
    suggested: true,
  },
];

export const isObject = (variable) =>
  typeof variable === "object" && !Array.isArray(variable) && variable !== null;

export const numberToShort = (value, round = false) => {
  if (value > 999999) {
    return `${(value / 1000000).toFixed(
      value / 1000000 - Math.floor(value / 1000000) < 0.1 || round ? 0 : 1
    )}m`;
  }
  if (value > 999) {
    return `${(value / 1000).toFixed(
      value / 1000 - Math.floor(value / 1000) < 0.1 || round ? 0 : 1
    )}k`;
  }
  return value;
};

export const hexToRGB = (hex) =>
  parseInt(hex.slice(1, 3), 16) +
  ", " +
  parseInt(hex.slice(3, 5), 16) +
  ", " +
  parseInt(hex.slice(5, 7), 16);

export const getLastUsedVoicesFromLocalStorageObject = (
  lastUsedData,
  isTTS
) => {
  const lastUsedVoices = Object.keys(lastUsedData)
    .map((k) => lastUsedData[k])
    .filter((item) => !!item.narrationStyle)
    .reduce((a, c) => {
      if (isTTS) {
        if (
          !a.find(
            (tmp) => tmp.id === c.id && tmp.narrationStyle === c.narrationStyle
          )
        ) {
          a.push(c);
        }
      } else {
        if (
          !a.find(
            (tmp) =>
              tmp.id === c.id &&
              tmp.accent === c.accent &&
              tmp.pitch === c.pitch
          )
        ) {
          a.push(c);
        }
      }
      return a;
    }, [])
    .slice(-LAST_USED_VOICES_COUNT);

  return lastUsedVoices;
};
